<template>
  <div class="popupBox">
    <h1>{{ popupLocation }}</h1>
    <!-- 投票成功後使用 -->
    <!-- <a v-if="popupLocation == 'successVote'" href="https://line.me/R/ti/p/@374zoemd"><img class="popup"
        src="@/assets/img/popup/i1.png"></a> -->
    <p v-if="popupLocation === 'linePopup'" class="popup">本計畫內容只提供行動裝置直式瀏覽唷！</p>
    <router-link v-if="popupLocation === 'successVote'" to="/" class="successVote">
      <img class="popup" src="@/assets/img/popup/i2.png"></router-link>
    <!-- 送出報名表單後使用 -->
    <router-link v-if="popupLocation === 'detailPopup'" to="/" class="makeSure">
      <img class="popup" src="@/assets/img/popup/i1.png"></router-link>
    <!-- 首頁youtobe使用 -->
    <div v-if="popupLocation == 'youtoPopup'" class="youtoBox popup">
      <iframe width="100%" height="250" src="https://www.youtube.com/embed/iZ0aTPi4fR4" title="YouTube video player"
        frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </div>
    <!-- 送出報名表單後使用 -->
    <div v-if="popupLocation == 'signDeadline'" class="bgW popup"  @click="closePopup">
      <p>共想計畫報名徵件已於2022/09/30截止，歡迎至大眾的溫柔投下您寶貴的一票，投票時間到2022/10/14中午12:00止，一同讓溫柔茁壯！</p>
      <router-link to="/listPage" @click.native="$emit('addTags',tags.goToListPage,null, null ,null)">立即投票</router-link>
    </div>

    <!-- popup背景 -->
    <button @click="closePopup">
      <div class="popupBG"></div>
    </button>

  </div>
</template>

<script>
  export default {
    name: 'popupBox',
    props: {
      popupLocation: String
    },
    data() {
      return {
        tags:{
          goToListPage:'35283B5FC668488BA694DCCAA0515860'
        },
      }
    },
    methods: {
      closePopup: function () {
        this.$emit('popupStatus', 0);
      },
    },
    watch: {},
    created: function () {},
    mounted: function () {},
  }
</script>
<style lang="scss">
  .popup {
    position: fixed;
    z-index: 111;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
  }

  .bgW{
    background-color: #ffffff;
    border-radius: 20px;
    padding: 20px;
    a{
      color: #ffffff;
      text-align: center;
      display: block;
      margin: 20px auto 0 auto;
      width: 100px;
      border-radius: 40px;
      background-color: #673500;
      padding: 10px 25px;
    }
  }

  .popupBG {
    opacity: 0.85;
    background-color: #ffeb00;
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    width: 100vw;
    z-index: 110;
  }

  p {
    text-align: center;
    color: var(--main1);
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->